import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import trainingLibraryRoutes from 'modules/trainingLibrary/TrainingLibrary/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const AproDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityDetailsAproDetails" */ 'modules/activityDetails/AproDetails/pages/AproDetails'
    )
)

const AproDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={routes.root} component={AproDetails} />
      <Redirect path='*' to={trainingLibraryRoutes.root} />
    </Switch>
  </Suspense>
)

export default AproDetailsRouting
